import React from 'react';
import { Layout, Spin, message } from 'antd';

import menuList from "./menulist.js"
import Menu from "./menu.js"
import Head from './head.js';
import Intro from './intro.js';
import TipModal from './tipModal.js';
import common from '../assets/common.js';
import logo from '../images/logo.svg';
import logoL from '../images/logo-l.svg';
import './index.css';

const { Content, Sider, Footer } = Layout;

class Body extends React.Component {
  constructor(props){
    super(props);
    const modalType = common.getCookie("tip") === "none" ? "" : "tip";
    // const modalType = "tip";
    this.state = {
      admin : {},
      loading : false,
      collapsed : false,
      modalType,
      modalData : ""
    }
  }
  componentWillMount(){
    const menu = this.props.location.pathname;
    var parents = common.lookUpParent(menuList.list, "sub", "key", menu)[0];
    switch(menu) {
      case "/compatible":
      case "/login":
      case "/submanage":
      case "/submanage/manage":
        break;
      default:
        this.getInfo(menu)
        break;
    }
    if(!parents) {
      window.location.href = "#/login";
    }
  }
  componentWillReceiveProps(props){
    const menu = props.location.pathname;
    switch(menu) {
      case "/compatible":
      case "/login":
      case "/submanage":
      case "/submanage/manage":
        break;
      default:
        this.getInfo(menu)
        break;
    }
  }
  getInfo = (menu) => {
    var postData = {};
    postData["_url"] = "admin/checkLogin";
    common.request(postData, this, function(obj, data){
      const result = data.data;
      if(result.orgId) {
        // const info = Object.assign(common.getCookie("info") ? JSON.parse(common.getCookie("info")) : {}, result);
        const info = result;
        if(!result.authority) result.authority = "[]";
        window.info = info;
        common.setCookie("info", JSON.stringify(info));
        // window.info = result;
        obj.setState({ info });
      } else {
        switch(menu){
          case "/login":case "/submanage":
            break;
          default:
            obj.props.history.push('/login');
            break;
        }
      }
    },function(obj, data){
      if(data.code === "100028"){
        if(menu !== "/login") obj.props.history.push('/login');
      } else {
        message.warning(data.message);
      }
    });
  }
  changeCollapsed = (collapsed) => {
    this.setState({
      openKeys : []
    }, function(){
      setTimeout(this.setState({ collapsed }) ,1000)
    })
  }
  toIndex = () => {
    const menu = this.props.location.pathname;
    if(menu) {
      this.props.history.push("/overview")
    }
  }
  showModal = (modalType, modalData) => {
    switch(modalType){
      case "":
        this.setState({ modalType }, function(){
          this.setState({ modalType, modalData })
        })
        break;
      case "tipclose":
        common.setCookie("tip", "none")
        this.setState({ modalType }, function(){
          this.setState({ modalType, modalData })
        })
        break;
      default:
        this.setState({ modalType, modalData })
        break;

    }
  }
  render() {
    const { loading, collapsed, info, modalType } = this.state;
    const menu = this.props.location.pathname;
    const history = this.props.history;
    var parents = common.lookUpParent(menuList.list, "sub", "key", menu)[0];
    var sub = "";
    if(!parents) {
      return <div></div>
    } else {
      var menuKey = parents[0];
      window.menu = menu;
      window.path = menuKey.key;
      sub = React.createElement(menuKey.content, {
        menu : menu,
        history : history,
        parent : menuKey.key
      })
    }
    var main = <div></div>;
    const orginfo = window.info;
    const FooterSlider = () => <Footer id="footerMessage" className="text-center">   Copyright © 2012 - 2018 Yunban. All Rights Reserved. <a className="footer-href" href="https://www.yunban.com">云瓣科技</a> 版权所有 云瓣法律顾问：易法通 </Footer>
    switch(menu){
      case "/compatible":
        main = sub;
        break;
      case "/login":
        main = sub
        break;
      case "/submanage":case "/submanage/manage":
        main = <Layout id="mainLayout">
          <Layout id="contentLayout">
            <Layout id="subLayout">
              <Intro parents={ parents } history={ history }/>
              <Content id="contentDesc">
                { sub }
              </Content>
            </Layout>
            <FooterSlider />
          </Layout>
        </Layout>
        break;
      case "/404":case "/403":case "/500":
        main = orginfo && orginfo.orgName ? <Layout id="mainLayout">
          <Sider
            id="menuSlider"
            collapsed={ collapsed }
            onCollapse={ this.onCollapse }
            width="256px"
          >
            <div id="logoDiv" className="cursor-pointer" onClick={ this.toIndex }>
              { collapsed ?
                <img src={ logo } height="28px"  alt="logo"/> :
                <img src={ logoL } height="28px" alt="logo"/>
              }
            </div>
            <Menu collapsed={ collapsed } menu={ menu } info={ info } history={ history }/>
          </Sider>
          <Layout id="contentLayout" className={ collapsed ? "collapsed hasHead" : "nocollapsed hasHead" }>
            <Head changeCollapsed={ this.changeCollapsed.bind(this) } collapsed={ collapsed } history={ history }/>
            <Layout id="subLayout">
              <Content id="contentDesc">
                {
                  loading ?
                  <Spin/> :
                  <div id="mainContent" className="relative">
                    { orginfo && sub }
                  </div>
                }
              </Content>
            </Layout>
            <FooterSlider />
          </Layout>
        </Layout> :
        <div></div>
        break;
      default:
        main = orginfo && orginfo.orgName ? <Layout id="mainLayout">
          <Sider
            id="menuSlider"
            collapsed={ collapsed }
            onCollapse={ this.onCollapse }
            width="256px"
          >
            <div id="logoDiv" className="cursor-pointer" onClick={ this.toIndex }>
              { collapsed ?
                <img src={ logo } height="28px"  alt="logo"/> :
                <img src={ logoL } height="28px" alt="logo"/>
              }
            </div>
            <Menu collapsed={ collapsed } menu={ menu } info={ info } history={ history }/>
          </Sider>
          <Layout id="contentLayout" className={ collapsed ? "collapsed hasHead" : "nocollapsed hasHead" }>
            <Head changeCollapsed={ this.changeCollapsed.bind(this) } collapsed={ collapsed } history={ history }/>
            <Layout id="subLayout">
              <Intro parents={ parents } history={ history }/>
              <Content id="contentDesc">
                {
                  loading ?
                  <Spin/> :
                  <div id="mainContent" className="relative">
                    { orginfo && sub }
                  </div>
                }
              </Content>
            </Layout>
            <FooterSlider />
          </Layout>
          <TipModal modalType={ modalType } showModal={ this.showModal.bind(this) }></TipModal>
        </Layout> :
        <div></div>
        break;
    }
    return main
  }
}

export default Body;



// WEBPACK FOOTER //
// ./src/index/main.js